import { createSlice } from '@reduxjs/toolkit';

const calendarFormSlice = createSlice({
  name: 'calendarForm',

  initialState: {
    activeTimeLength: -1,
    activeTimeFrame: -1,
    datePicked: '',
    timeLengthPicked: '',
    timePicked: '',
    firstName: '',
    lastName: '',
    phoneNumber: '',
    emailAddress: '',
  },

  reducers: {
    setActiveTimeFrame(state, action) {
      state.activeTimeFrame = action.payload;
    },

    setActiveTimeLength(state, action) {
      state.activeTimeLength = action.payload;
    },

    setDate(state, action) {
      state.datePicked = action.payload;
    },

    setTimeLength(state, action) {
      state.timeLengthPicked = action.payload;
    },

    setTime(state, action) {
      state.timePicked = action.payload;
    },

    setFormContent(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },

    resetFormContent() {
      return {
        activeTimeLength: -1,
        activeTimeFrame: -1,
        datePicked: '',
        timeLengthPicked: '',
        timePicked: '',
        firstName: '',
        lastName: '',
        phoneNumber: '',
        emailAddress: '',
      };
    },
  },
});

export const calendarFormReducer = calendarFormSlice.reducer;
export const {
  setDate,
  setTimeLength,
  setTime,
  setActiveTimeFrame,
  setActiveTimeLength,
  setFormContent,
  resetFormContent,
} = calendarFormSlice.actions;
